module.exports = __webpack_public_path__ + "static/media/carte-bulgarie.45ab8e1e.svg_old";